import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Meshy image-to-3d-pro run.
 * Pulls the user-uploaded input image from inputAssets, derives material from
 * enablePbr/geometryOnly, and opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyImageTo3dProData = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    enablePbr,
    geometryOnly,
    inputAssets,
    outputAssets,
    private: isPrivate,
    useCase,
  } = openedModel
  const {
    targetPolycount,
    topology: polygonType,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterial(enablePbr, geometryOnly)
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getAssetByTypeAndSource(inputAssets, 'image', 'user_upload')
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.MESHY
  const generationAction = ACTION.IMAGE_TO_3D
  const isSmartLowPoly = false

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  const modelSettings = {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    isSmartLowPoly,
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    viewer,
    ui,
    generation,
  }
}
